import { enUS } from 'date-fns/locale'

export const defaultCopy = {
  locale: enUS,
  titleBar: {
    text: 'Choose date',
    closeLabel: 'close',
  },
  dropdowns: {
    monthLabel: 'Month',
    yearLabel: 'Year',
  },
  navigation: {
    previous: 'Go to previous month',
    next: 'Go to next month',
  },
}

export type Copy = typeof defaultCopy
